var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"reg pointer",on:{"click":_vm.showInspirationCenter}},[_vm._v("Inspiration Center")])
}
var staticRenderFns = []

export { render, staticRenderFns }